<template>
    <div>
        <Form
            :items="formData.gameId ? updateItems(idx) : robotItems"
            :rules="rules"
            :formData="formData"
            v-for="(formData, idx) in formDatas"
            :key="idx"
            ref="form"
            labelWidth="120px"
            @change="handleChange($event, idx)"
        >
            <span slot="footer"></span>
        </Form>
        <div class="footer">
            <span v-show="formDatas[0].robotOperator" class="last-editor">{{
                `最后编辑人：${formDatas[0].robotOperator} ${formDatas[0].robotOperationTime}`
            }}</span>
            <el-button round @click="addHandler">{{ $t("zhiji.business.addRobot") }}</el-button>
            <el-button round type="primary" @click="submit">{{ $t("zhiji.common.save") }}</el-button>
        </div>
    </div>
</template>

<script>
import Form from "@/views/zhiji/components/form/Form";
import { allSupportLangs } from "@/components/langSelect/languages.js";
import { updateRobot, getRobots } from "../service.js";
import { isTestEnv } from "@/lib/utils/util";
import { getBusinessId } from "@/lib/auth";

export default {
    components: {
        Form
    },
    props: ["value", "languages", "maxNum"],
    data() {
        const count = this.maxNum || 10; // 默认支持10个
        const innerValues = (this.value || []).length ? this.value.slice(0) : [{}];

        return {
            rules: {
                robotName: [{ required: true, message: this.$t("zhiji.business.pleaseInput") + this.$t("zhiji.business.enName"), trigger: "blur" }],
                defaultLang: [
                    { required: true, message: this.$t("zhiji.business.pleaseSelect") + this.$t("zhiji.business.defaultLang"), trigger: "change" }
                ],
                source: [
                    {
                        type: "array",
                        required: true,
                        trigger: "input",
                        validator: (rule, value, callback) => {
                            setTimeout(() => {
                                if (value.length == 0 || value.some(v => v == "")) {
                                    callback(new Error(this.$t("zhiji.business.pleaseInput") + this.$t("im.channel")));
                                } else {
                                    callback();
                                }
                            });
                        }
                    }
                ]
            },
            formDatas: innerValues,
            maxCount: count,
            minCount: 1,
            initRobots: []
        };
    },
    computed: {
        isTestEnv() {
            return isTestEnv();
        },
        robotItems() {
            const items = this.getFormItems();
            return items;
        }
    },
    watch: {
        value() {
            const innerValues = (this.value || []).length ? this.value.slice(0) : [{}];
            this.formDatas.splice(0, this.formDatas.length, ...innerValues);
        }
    },
    async mounted() {
        if (!this.isTestEnv) {
            return;
        }
        const businessId = getBusinessId();
        this.initRobots = await getRobots(businessId);
    },
    methods: {
        submit() {
            const triggerSave = async () => {
                await updateRobot(this.formDatas);
                this.$emit("submit", this.formDatas);
            };

            // 校验只有所有表单都通过了才提交
            const total = this.formDatas.length;
            let count = 0;
            this.$refs.form.forEach(form => {
                form.validate(async isValid => {
                    if (!isValid) {
                        return;
                    }
                    ++count;
                    if (count === total) {
                        triggerSave();
                    }
                });
            });
        },
        addHandler() {
            this.formDatas.push({});
        },
        updateItems(idx) {
            const items = this.getFormItems(idx);
            items[1].extendProps.disabled = true; // 更新时,不能更新默认语言
            return items;
        },
        handleChange(newData, idx) {
            // 测试环境填充默认语言和渠道
            if (this.isTestEnv && newData.gameId) {
                const r = this.initRobots.find(g => g.gameId === newData.gameId);
                newData.defaultLang = r.defaultLang;
                newData.robotName = r.robotName;
            }

            this.formDatas.splice(idx, 1, { ...this.formDatas[idx], ...newData });
        },
        getFormItems(idx) {
            return [
                this.isTestEnv
                    ? {
                          name: "gameId",
                          label: this.$t("zhiji.business.enName"),
                          type: "Select",
                          extendProps: {
                              placeholder: this.$t("zhiji.business.pleaseInput") + this.$t("zhiji.business.enName"),
                              options: this.initRobots.map(item => {
                                  const disabled = !!this.formDatas.find(fd => fd.gameId === item.gameId);
                                  return { value: item.gameId, label: item.robotName, disabled };
                              }),
                              filterable: true
                          }
                      }
                    : {
                          name: "robotName",
                          label: this.$t("zhiji.business.enName"),
                          type: "el-input",
                          extendProps: {
                              placeholder: this.$t("zhiji.business.pleaseInput") + this.$t("zhiji.business.enName")
                          }
                      },
                {
                    name: "defaultLang",
                    label: this.$t("zhiji.business.defaultLang"),
                    type: "Select",
                    extendProps: {
                        placeholder: this.$t("zhiji.business.pleaseSelect") + this.$t("zhiji.business.defaultLang"),
                        options: allSupportLangs
                            .filter(lang => this.languages.indexOf(lang.lang) != -1)
                            .map(lang => ({ value: lang.lang, i18nKey: lang.i18nKey })),
                        filterable: true,
                        disabled: this.isTestEnv
                    }
                },
                this.isTestEnv && idx != null
                    ? {
                          name: "source",
                          label: this.$t("im.channel"),
                          type: "ArraySelect",
                          extendProps: {
                              placeholder: this.$t("zhiji.business.pleaseInput") + this.$t("im.channel"),
                              maxlength: 16,
                              options: this.initRobots[idx].source,
                              filterable: true
                          }
                      }
                    : {
                          name: "source",
                          label: this.$t("im.channel"),
                          type: "ArrayInput",
                          extendProps: {
                              placeholder: this.$t("zhiji.business.pleaseInput") + this.$t("im.channel"),
                              maxlength: 16,
                              disabled: this.isTestEnv
                          }
                      },
                ...(this.isTestEnv
                    ? [
                          {
                              name: "robotName",
                              label: this.$t("zhiji.business.enName"),
                              type: "el-input",
                              hidden: true
                          }
                      ]
                    : [
                          {
                              name: "gameId",
                              label: this.$t("zhiji.business.enName"),
                              type: "el-input",
                              hidden: true
                          }
                      ])
            ];
        }
    }
};
</script>

<style scoped>
.footer {
    display: flex;
    justify-content: flex-end;
}
.last-editor {
    font-size: 14px;
    padding-top: 5px;
    vertical-align: middle;
}
</style>
